"use strict";
/**
 * This code was AUTOGENERATED using the kinobi library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun kinobi to update it.
 *
 * @see https://github.com/metaplex-foundation/kinobi
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.getProofInfoSerializer = void 0;
const serializers_1 = require("@metaplex-foundation/umi/serializers");
function getProofInfoSerializer() {
    return (0, serializers_1.struct)([['proof', (0, serializers_1.array)((0, serializers_1.bytes)({ size: 32 }))]], {
        description: 'ProofInfo',
    });
}
exports.getProofInfoSerializer = getProofInfoSerializer;
//# sourceMappingURL=proofInfo.js.map